import React, { Component } from 'react';
import { connect } from 'react-redux';
import Parser from 'html-react-parser'
import {Link} from 'react-router-dom';
import { slugify } from "../../../SHARED/helpers/general.helper";

class CinemapCard extends Component {

    render() {
        return (
           <div className={'card-item ' + this.props.color}>
               <div className="card-ribbon" style={{backgroundColor: this.props.color} }>
                   { this.props.headline }
               </div>
               <Link to={`/stire/${this.props.id}/${slugify(this.props.title)}`} >
                   <img alt={'Film'} src={ this.props.image } />
               </Link>
               <div className="wrapper-overlay">
                   <div className="overlay">
                       <Link to={`/stire/${this.props.id}/${slugify(this.props.title)}`} >
                           { Parser(this.props.title) }
                       </Link>
                   </div>
               </div>
               <div className="wrapper-overlay-under" style={{backgroundColor: this.props.color}}>
                </div>
               <div className="card-descr">
                   <span className="card-date">{ this.props.date }</span><br/>
                   { Parser(this.props.description) }
                   <br/>
                    <Link to={`/stire/${this.props.id}/${slugify(this.props.title)}`} >
                        <span className="read-more">Citeşte tot >></span>
                    </Link>
               </div>
           </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(CinemapCard);



// WEBPACK FOOTER //
// ./src/SHARED/components/card/card.component.js